<div mat-dialog-content>
    <div *ngIf="isLoading" class="overlay"></div>
    <div *ngIf="isLoading" class="loader"></div>
    <div mat-tab-group class="mat-tab-group">
        <div mat-tab label="General Data">
            <div mat-card>
                <div mat-card-content>
                    <h1 class="menu-sub-item-header mat-icon-container">{{isUpdate ? 'Maintain' : 'Create'}} Watch</h1>
                    <p>
                    <form [formGroup]="watchForm">

                        <div class="col">
                            <div class="col1">
                                <div class="mat-form-small-container">
                                    <label>Store: </label>
                                </div>
                            </div>
                            <div class="col2">
                                <div class="mat-form-small-container">
                                    <!--<input name="store" matInput formControlName="store" required />-->
                                    <kendo-combobox
                                        style="width: 400px"
                                        [data]="listItemsStore"
                                        [allowCustom]="allowCustom"
                                        [value]="selectedValues"
                                        (valueChange)="onSizeChange($event)"
                                        >
                                    </kendo-combobox>
                                </div>
                            </div>
                        </div>

                        <!--<div class="col">
                            <div class="col1">
                                <div class="mat-form-small-container">
                                    <label>Category: </label>
                                </div>
                            </div>
                            <div class="col2">
                                <div class="mat-form-small-container">
                                    <input name="category" matInput formControlName="category" required />
                                </div>
                            </div>
                        </div> -->

                        <div class="col">
                            <div class="col1">
                                <div class="mat-form-small-container">
                                    <label>Name: </label>
                                </div>
                            </div>
                            <div class="col2">
                                <div class="mat-form-small-container">
                                    <input  name="name" matInput readonly="true" formControlName="name" />
                                    <input  name="importFileName" matInput hidden="true"  formControlName="importFileName" />
                                </div>
                            </div>
                        </div>

                        <div class="col">
                            <div class="col1">
                                <div class="mat-form-small-container">
                                    <label>Description: </label>
                                </div>
                            </div>
                            <div class="col2">
                                <div>
                                    <mat-form-field appearance="outline">
                                        <textarea  name="description" matInput cols="40"  formControlName="description" rows="3"></textarea>
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>

                        <div class="col">
                            <div class="col1">
                                <div class="mat-form-small-container">
                                    Upload File:
                                </div>
                            </div>
                            <div class="col2">
                                <div class="mat-form-small-container">
                                    <kendo-fileselect formControlName="myFiles" style="width: 100%;"> </kendo-fileselect>
                                </div>
                            </div>
                        </div>

                    </form>
                    
                </div>
                <div mat-card-actions class="mat-form-button-container">
                    <div class="flex flex-align-items-center">
                        <div class="mr-auto">
                        </div>
                        <button style="float: none;" type="button" mat-raised-button (click)="dialogRef.close()"
                            color="warn">Cancel</button>
                        <button style="float: none;" type="button" mat-raised-button (click)="isUpdate ? updateWatch() : addWatch()" color="warn"
                            [disabled]="isUpdate">{{isUpdate ? 'Save' : 'Add'}}</button>
                        <button style="float: none;" type="button" mat-raised-button (click)="removeImport()"
                            color="warn">Cancel Import</button>
                    </div>
                    <br/>
                </div>
            </div>
        </div>

    </div>
</div>
